import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';
import { HostProvider } from '../../utils/HostProvider';

const NotFound: FC = () => {
  const { t } = useTranslation();
  const isCaprabo = HostProvider.isCaprabo();
  const dataApp = useAppStore();
  const language = dataApp && dataApp.lang ? dataApp.lang : 'es';

  const URL_CLUB = isCaprabo
    ? `${process.env.REACT_APP_API_CAPRABO}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_CLUB_CAPRABO
      }${language}/clubcaprabo/&fromApp=${t('caprabo_com')}`
    : `${process.env.REACT_APP_API}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_SERVER_EROSKI_ES
      }${t('link.eroskies')}eroski-club/&fromApp=${t('eroski_es')}`;
  const redirect = () => {
    document.location.href = URL_CLUB;
  };

  return (
    <>
      <section className="o-section--medium">
        <div className="container-inner u-margin-top-hero">
          <div className="u-text-center">
            <h1 className="titulo-pagina u-margin-bottom-medium">
              {t('pantalla-error.titulo')}
            </h1>
            <p className="u-margin-bottom-large">
              {t('pantalla-error.mensaje-cuerpo')}
            </p>

            <div className="u-margin-bottom-extrahuge">
              <button
                className="btn btn-default"
                type="button"
                onClick={redirect}
              >
                {t('pantalla-error.ir-a-la-home')}
              </button>
            </div>

            <div className="img img__error u-margin-bottom-extrahuge">
              <img
                src="/assets/images/carro-error.png"
                alt="Imagen de un carro de supermercado"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
